<script>
import VacancyListItem from "./VacancyListItem.vue";

export default {
    name: "VacancyOverview",
    components: {VacancyListItem},

    data() {
        return {
            showPlaceholders: true,
            infiniteScrollActive: false,
            isLoading: true,
            eventBus: new Vue(),
            items: [],
            filters: {},
            meta: [],
            appliedFilters: [],
            page: 1,
        }
    },

    computed: {
        hasFilters() {
            return !_.isEmpty(this.filters);
        },

        hasItems() {
            return !_.isEmpty(this.items);
        },
    },

    mounted() {
        this.fetchData();

        this.eventBus.$on('dropdown-changed', payload => {
            this.handleDropdownChanged(payload);
        });

        this.eventBus.$on('dropdown-emptied', payload => {
            this.handleDropdownEmptied(payload);
        });
    },

    methods: {
        fetchData() {
            this.isLoading = true;

            axios.get('/api/vacancies', {
                params: {
                    filters: JSON.stringify(this.appliedFilters),
                    page: this.page,
                }
            }).then(response => {
                if (response.data.meta.currentPage === 1) {
                    this.items = response.data.data;
                    this.filters = response.data.filters;
                }

                if (response.data.meta.currentPage >= 2) {
                    this.items = this.$set(this, 'items', [...this.items, ...response.data.data]);
                }

                this.meta = response.data.meta;
                this.infiniteScrollActive = !lodash.isNil(response.data.meta.nextPage);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.isLoading = false;
                this.showPlaceholders = false;

                if (this.hasLocalStorage === true) {
                    this.handleLocalStorageFilters();
                }
            });
        },

        handleDropdownChanged(payload) {
            let filter = _.find(this.appliedFilters, {
                'key': payload.filterKey
            });

            if (lodash.isNil(filter)) {
                this.appliedFilters.push({
                    key: payload.filterKey,
                    value: payload.value,
                    type: payload.type
                })
            }

            if (!lodash.isNil(filter)) {
                filter.value = payload.value;
            }

            this.page = 1;
            this.fetchData();
        },

        handleDropdownEmptied(payload) {
            let filter = _.find(this.appliedFilters, {
                'key': payload
            });

            this.appliedFilters.splice(this.appliedFilters.indexOf(filter), 1);

            this.page = 1;
            this.fetchData();
        },

        handleLoaderVisibility(payload) {
            if (!payload.visible || this.isLoading === true) {
                return;
            }

            this.page++;
            this.fetchData();
        },

        handleResetFilters() {
            this.eventBus.$emit('reset-filters');
            this.appliedFilters = [];
            this.page = 1;
            this.fetchData();
        }
    }
}
</script>

<template>
<div class="vue-vacancy-overview vue-occasions-overview">
    <slot v-if="showPlaceholders"></slot>

    <div class="row" v-if="!showPlaceholders">
        <div class="col-xl-3 col-lg-12 region-filters">
            <div class="col-12">
                <p class="mb-4 filter-title d-flex justify-content-between align-items-center"><strong>Filter</strong> <span class="reset-filters" @click="handleResetFilters">reset filters</span></p>
            </div>

            <occasion-filter-group title="Garage" :show-open="true" v-if="filters.field_garage.length > 1">
                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Garage" :options="filters.field_garage" filter-key="field_garage" :check-local-storage-value="false"></occasion-dropdown-filter>
            </occasion-filter-group>

            <occasion-filter-group title="Functie" :show-open="true" v-if="filters.field_title.length > 1">
                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Functie" :options="filters.field_title" filter-key="field_title" :check-local-storage-value="false"></occasion-dropdown-filter>
            </occasion-filter-group>

            <occasion-filter-group title="Type baan" :show-open="true" v-if="filters.field_job_type.length > 1">
                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Type baan" :options="filters.field_job_type" filter-key="field_job_type" :check-local-storage-value="false"></occasion-dropdown-filter>
            </occasion-filter-group>

            <occasion-filter-group title="Provincie" v-if="filters.field_province.length > 1">
                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Provincie" :options="filters.field_province" filter-key="field_province" :check-local-storage-value="false"></occasion-dropdown-filter>
            </occasion-filter-group>

            <occasion-filter-group title="Opleiding" v-if="filters.field_education.length > 1">
                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Opleiding" :options="filters.field_education" filter-key="field_education" :check-local-storage-value="false"></occasion-dropdown-filter>
            </occasion-filter-group>

            <occasion-filter-group title="Ervaring" v-if="filters.field_experience.length > 1">
                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Ervaring" :options="filters.field_experience" filter-key="field_experience" :check-local-storage-value="false"></occasion-dropdown-filter>
            </occasion-filter-group>
        </div>

        <div class="col-xl-9 col-lg-12 mt-3 mt-xl-0">
            <div class="row mb-4 occasion-metas">
                <div class="col-md-6">
                    <p><strong>{{ meta.items }} resultaten</strong></p>
                </div>
            </div>

            <template v-if="hasItems === true">
                <div class="occasion-list-wrapper vacancy-list-wrapper" :class="{'loading-occasions': isLoading}">
                    <VacancyListItem v-for="item in items" :key="`vacancy-${item.id}`" :item="item" />
                    <loader v-if="infiniteScrollActive === true" @loader-visibility="handleLoaderVisibility"></loader>
                </div>
            </template>

            <template v-if="hasItems === false && isLoading === false">
                <h3>Geen resultaten</h3>
                <p>Geen resultaten, pas de filters aan.</p>
            </template>
        </div>
    </div>
</div>
</template>